var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0C0.895431 0 0 0.895428 0 2V8.2C0 9.30457 0.895433 10.2 2 10.2H11.8C12.9046 10.2 13.8 9.30457 13.8 8.2V2C13.8 0.895431 12.9046 0 11.8 0H2ZM3.4 2.4C2.84772 2.4 2.4 2.84772 2.4 3.4V6.8C2.4 7.35228 2.84772 7.8 3.4 7.8H10.4C10.9523 7.8 11.4 7.35228 11.4 6.8V3.4C11.4 2.84772 10.9523 2.4 10.4 2.4H3.4Z",
    fill: "#C6C6C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2 19.8C17.0954 19.8 16.2 20.6954 16.2 21.8V28C16.2 29.1046 17.0954 30 18.2 30H28C29.1045 30 30 29.1046 30 28V21.8C30 20.6954 29.1045 19.8 27.9999 19.8H18.2ZM19.5998 22.2C19.0475 22.2 18.5998 22.6477 18.5998 23.2V26.6C18.5998 27.1523 19.0475 27.6 19.5998 27.6H26.5998C27.152 27.6 27.5998 27.1523 27.5998 26.6V23.2C27.5998 22.6477 27.152 22.2 26.5998 22.2H19.5998Z",
    fill: "#C6C6C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2 0C17.0954 0 16.2 0.895429 16.2 2V15.4C16.2 16.5046 17.0954 17.4 18.2 17.4H28C29.1045 17.4 30 16.5046 30 15.4V2C30 0.895431 29.1045 0 27.9999 0H18.2ZM19.5998 2.4C19.0475 2.4 18.5998 2.84771 18.5998 3.4V14C18.5998 14.5523 19.0475 15 19.5998 15H26.5998C27.152 15 27.5998 14.5523 27.5998 14V3.4C27.5998 2.84772 27.152 2.4 26.5998 2.4H19.5998Z",
    fill: "#C6C6C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12.6C0.895431 12.6 0 13.4954 0 14.6V28C0 29.1046 0.895433 30 2 30H11.8C12.9046 30 13.8 29.1046 13.8 28V14.6C13.8 13.4954 12.9046 12.6 11.8 12.6H2ZM3.4 15C2.84772 15 2.4 15.4477 2.4 16V26.6C2.4 27.1523 2.84772 27.6 3.4 27.6H10.4C10.9523 27.6 11.4 27.1523 11.4 26.6V16C11.4 15.4477 10.9523 15 10.4 15H3.4Z",
    fill: "#C6C6C6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.978ae46b5ac20af3d91b8bf18282451a.svg";
export { ForwardRef as ReactComponent };